module.exports = __webpack_public_path__ + "img/featuredartist (4).ef0e3901.jpg";